<template v-if="isLoaded">
  <InputText
    keyId="0"
    :placeholder="item.label"
    label="Rubrik för fältet"
    :model="item.label"
    type="text"
    @change="onLabelChange"
    class="col-span-full"
  ></InputText>
  <button
    @click="addNewPeriod"
    class="mt-4 col-span-full flex gap-2 items-center text-blue-1 hover:text-blue-2 cursor-pointer"
  >
    <i class="fas fa-plus"></i>
    <span>Lägg till period</span>
  </button>
  <div class="flex flex-col gap-4 mt-4">
    <div
      :key="index"
      v-for="(period, index) in withoutGroup"
      class="flex flex-col gap-4 bg-white ring-1 ring-orange-2 p-4 rounded-lg"
    >
      <div class="w-full flex gap-4 justify-between">
        <div class="flex gap-2 items-center">
          <input
            v-model="period.Period.start"
            type="date"
            class="border bg-blue-4 border-gray-2 px-2 py-1 w-48 rounded focus:outline-none focus:border-blue-3"
            placeholder="Ange startdatum"
          />
          <svg
            class="w-4 h-4 mx-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
          <input
            v-model="period.Period.end"
            type="date"
            placeholder="Ange slutdatum"
            class="border bg-blue-4 border-gray-2 px-2 py-1 w-48 rounded focus:outline-none focus:border-blue-3"
          />
        </div>
        <div class="flex items-center gap-4">
          <button
            @click="removePeriod(period)"
            title="Ta bort period"
            class="text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
          >
            <span>Ta bort period</span>
            <i class="fas fa-close"></i>
          </button>
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <MinMaxAgeInPeriod
          :item="period.input"
          :index="(index * 2).toString()"
          :period-key="period.input.key"
          @input="onInput"
          @remove-validation="removeAdvancedValidation"
          @save-validation="saveValidation"
        />
      </div>
    </div>
  </div>
  <div class="flex col-span-full gap-4 mt-4">
    <RegularButton
      @click="
        () => {
          emit('removeField');
        }
      "
      style-type="cancel"
      text="Ta bort fält"
    />
    <RegularButton
      @click="
        () => {
          emit('back');
        }
      "
      text="Tillbaka"
    />
  </div>
</template>
<script setup lang="ts">
import {
  defineEmits,
  defineProps,
  ref,
  reactive,
  onMounted,
  computed,
} from "vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import "v-calendar/dist/style.css";
import { DynamicProperty } from "@/models/dtos";

import MinMaxAgeInPeriod from "../validators/MinMaxAgeInPeriod.vue";
import { RangeRoot } from "@/models/forms/AgePeriod";
import RegularButton from "@/features/shared/components/ui/RegularButton.vue";

const emit = defineEmits<{
  (event: "add", key: string, item: DynamicProperty): void;
  (event: "remove", key: dtos.DynamicProperty): void;
  (event: "labelChange", e: any): void;
  (event: "back"): void;
  (event: "removeField", item: DynamicProperty): void;
  (event: "saveItem", item: DynamicProperty): void;
}>();

const periodsWithRange = reactive(new Array<RangeRoot>());

const withoutGroup = computed(() =>
  periodsWithRange.filter((px) => px.input.type !== "periodGroup")
);

const props = defineProps({
  model: {
    type: dtos.DynamicProperty,
    required: true,
  },
  metadata: {
    type: dtos.MetaData,
    required: true,
  },
});
const isLoaded = ref(false);
onMounted(() => {
  if (Array.isArray(props.model.data.keys)) {
    const id = props.model.data.keys[0].id;
    if (typeof id !== typeof undefined)
      props.model.data.keys = props.model.data.keys.map((x: any) => x.key);
  }
  var properties = props.metadata.properties.filter((x) =>
    props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    periodsWithRange.push(new RangeRoot(x));
  });
  isLoaded.value = true;
});

const addNewPeriod = () => {
  const newPeriod = new dtos.DynamicProperty();

  newPeriod.placeholder = "";
  newPeriod.type = "periodCheckbox";
  newPeriod.key = crypto.randomUUID();
  newPeriod.label = "";
  newPeriod.data = new dtos.PeriodProperty("", "", false);
  periodsWithRange.push(new RangeRoot(newPeriod));

  emit("add", props.model.key, newPeriod);
};

function onLabelChange(event: any) {
  emit("labelChange", event);
}

const removePeriod = (period: RangeRoot) => {
  const index = periodsWithRange.indexOf(period);
  periodsWithRange.splice(index, 1);

  emit("remove", period.input);
};

const item = ref(props.model as dtos.DynamicProperty);

const onInput = (e: dtos.AllowedAgeInPeriod) => {};
const removeAdvancedValidation = (key: string) => {};

const saveValidation = (index: number, minAge: number, maxAge: number) => {};
</script>
